export function validateInitData(initData, { maxAgeSeconds = 3600 } = {}) {
  try {
    const params = new URLSearchParams(initData);
    const authDate = params.get('auth_date');
    if (!authDate) {
      return { valid: false, reason: 'auth_date отсутствует' };
    }

    const authTimestamp = parseInt(authDate, 10);
    if (Number.isNaN(authTimestamp)) {
      return { valid: false, reason: 'auth_date невалидный' };
    }

    const now = Math.floor(Date.now() / 1000);
    const age = now - authTimestamp;

    if (age > maxAgeSeconds) {
      return { valid: false, reason: `initData истёк (возраст: ${age}с, максимум: ${maxAgeSeconds}с)` };
    }
    if (age < 0) {
      return { valid: false, reason: 'auth_date в будущем (возможна подделка)' };
    }

    return { valid: true, age };
  } catch (error) {
    console.error('Ошибка валидации initData:', error);
    return { valid: false, reason: 'Ошибка парсинга initData' };
  }
}
